import * as Yup from "yup";

export const categorySchema = Yup.object().shape({
  name: Yup.string().required("Name field cannot be empty"),
  description: Yup.string().nullable(),
});
